export interface LiveSettings {
  sourceType: "direct" | "youtube" | "external" | "offline";
  hlsUrl: string;
  youtubeUrl: string;
  externalUrl: string;
  liveTitle: string;
  liveDescription: string;
  currentPresenter: string;
  currentProgram: string;
  nextProgram: string;
  isLive: boolean;
}

export interface SocialLinks {
  facebook: string;
  youtube: string;
  tiktok: string;
  instagram: string;
  twitter: string;
  whatsapp: string;
}

export const liveSettings: LiveSettings = {
  sourceType: "offline",
  hlsUrl: "",
  youtubeUrl: "",
  externalUrl: "",
  liveTitle: "L+TV LIVE",
  liveDescription: "L+TV is currently preparing its live broadcast. Please check back soon or browse our programs and videos.",
  currentPresenter: "L+TV Broadcast Team",
  currentProgram: "Preparing for Broadcast",
  nextProgram: "L+TV News Hour at 18:00",
  isLive: false,
};

export const socialLinks: SocialLinks = {
  facebook: "#",
  youtube: "#",
  tiktok: "#",
  instagram: "#",
  twitter: "#",
  whatsapp: "#",
};